﻿import ko from 'knockout'
import $ from 'jquery';
import Utility from "./utility"

export class JsonBuilder {
  public static toJSON(data: any): string {
    var pojo = ko.toJS(data);
    pojo.Rows = JsonBuilder.deleteEmptyArrayItems(pojo.Rows);
    JsonBuilder.setExcludeKeys(pojo);
    return JSON.stringify(pojo);
  }

  private static setExcludeKeys(obj) {
    if (obj && !Array.isArray(obj))
      obj.toJSON = () => JsonBuilder.toJsonFunc(obj);
    for (var o in obj) {
      if (obj.hasOwnProperty(o)) {
        if (typeof obj[o] != "object")
          continue;
        JsonBuilder.setExcludeKeys(obj[o]);
      }
    }
  }

  private static toJsonFunc = (obj) => {
    var rewrite = {};
    Object.keys(obj).forEach(key => {
      if (Utility.excludeKeys.indexOf(key) === -1)
        rewrite[key] = obj[key];
    });
    return rewrite;
  }

  private static deleteEmptyArrayItems<T>(arr: Array<T>) {
    var cleanedArr = [];
    for (var i = 0; i < arr.length; i++) {
      if (!Utility.isBlankItem(arr[i]))
        cleanedArr.push(arr[i]);
    }
    return cleanedArr;
  }
}

